import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * RichTextBlock - Public renderer for rich text content blocks
 * Mobile-first design, supports Markdown
 */
const RichTextBlock = ({ block, language = 'th' }) => {
  if (!block || block.type !== 'rich_text') {
    return null;
  }

  const config = block.config || {};
  const content = language === 'th'
    ? (config.content_th || config.content_en || '')
    : (config.content_en || config.content_th || '');

  // Don't render if no content
  if (!content || content.trim() === '') {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      {/* Mobile-first typography */}
      <div 
        className="prose prose-sm md:prose-lg max-w-none"
        style={{
          fontSize: '16px',
          lineHeight: '1.6',
          color: '#374151'
        }}
      >
        <ReactMarkdown
          components={{
            h1: ({node, ...props}) => <h1 style={{fontSize: '1.75rem', fontWeight: 700, marginTop: '1.5rem', marginBottom: '1rem', lineHeight: 1.2}} {...props} />,
            h2: ({node, ...props}) => <h2 style={{fontSize: '1.5rem', fontWeight: 700, marginTop: '1.25rem', marginBottom: '0.75rem', lineHeight: 1.3}} {...props} />,
            h3: ({node, ...props}) => <h3 style={{fontSize: '1.25rem', fontWeight: 600, marginTop: '1rem', marginBottom: '0.5rem', lineHeight: 1.4}} {...props} />,
            p: ({node, ...props}) => <p style={{marginTop: '1rem', marginBottom: '1rem'}} {...props} />,
            ul: ({node, ...props}) => <ul style={{marginTop: '1rem', marginBottom: '1rem', paddingLeft: '1.5rem'}} {...props} />,
            ol: ({node, ...props}) => <ol style={{marginTop: '1rem', marginBottom: '1rem', paddingLeft: '1.5rem'}} {...props} />,
            li: ({node, ...props}) => <li style={{marginTop: '0.5rem', marginBottom: '0.5rem'}} {...props} />,
            a: ({node, ...props}) => <a style={{color: '#2563eb', textDecoration: 'underline'}} {...props} />,
            strong: ({node, ...props}) => <strong style={{fontWeight: 700, color: '#111827'}} {...props} />,
            code: ({node, ...props}) => <code style={{backgroundColor: '#f3f4f6', padding: '0.125rem 0.375rem', borderRadius: '0.25rem', fontSize: '0.875em'}} {...props} />,
            blockquote: ({node, ...props}) => <blockquote style={{borderLeft: '4px solid #e5e7eb', paddingLeft: '1rem', marginLeft: 0, color: '#6b7280', fontStyle: 'italic'}} {...props} />
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default RichTextBlock;
